<template>
  <div class="app">
    <AppBar />
    <main class="app-main">
      <slot />
    </main>
    <AppTabBar />
    <ThemeSwitch />
    <PayoutFundVerifySheet />
  </div>
</template>

<style scoped>
.app-main {
  min-height: 0;
}
</style>
